/**
 * English strings of the admin area (milestone 7, slice 10): the queue of reports, sanctions, players,
 * feature flags, remote configuration, news and the log. `admin-it.ts` is typed against this shape.
 */
export const adminEn = {
  admin: {
    title: 'Team',
    signedInAs: 'Signed in as {{role}}',
    roles: { moderator: 'moderator', admin: 'admin' },
    gate: {
      loading: 'Checking who you are…',
      unavailable: 'The team area needs an account service, which this version does not have.',
      signIn: 'Sign in with your team account to see this.',
      signInAction: 'Go to the account',
      notStaff: 'This area is for the team.',
      needsFactor:
        'The team needs a second factor. Set up an authenticator app, and enter its code in this session.',
      needsFactorAction: 'Open security',
      adminOnly: 'This page is for admins.',
    },
    nav: { reports: 'Reports', players: 'Players', live: 'Live', audit: 'Log' },
    common: {
      reload: 'Reload',
      loading: 'Loading…',
      failed: 'That did not work. Try again.',
      forbidden: 'You are not allowed to do that.',
      saved: 'Saved.',
      save: 'Save',
      delete: 'Delete',
      apply: 'Apply',
      noteLabel: 'Note for the record (optional)',
      decision: 'Decision',
    },
    decisions: {
      dismiss: 'Dismiss: nothing wrong',
      warn: 'Warn',
      mute1: 'Mute chat for 1 hour',
      mute24: 'Mute chat for 24 hours',
      mute168: 'Mute chat for 7 days',
      muteForever: 'Mute chat until lifted',
      ban24: 'Ban for 24 hours',
      ban168: 'Ban for 7 days',
      banForever: 'Ban until lifted',
    },
    outcome: {
      done: 'Done.',
      notFound: 'Not found: the account may be gone.',
      alreadyResolved: 'Somebody else has already handled this report.',
    },
    reports: {
      title: 'Reports',
      status: { open: 'Open', actioned: 'Acted on', dismissed: 'Dismissed' },
      empty: 'No reports here.',
      by: 'Reported by {{name}}',
      gone: 'an account that is gone',
      counts: 'Open reports about this player: {{open}}. Sanctions on record: {{actions}}.',
      heist: 'Heist {{id}}',
    },
    players: {
      title: 'Players',
      lookup: 'Handle',
      lookupHint: 'Like Ada#0042.',
      lookupAction: 'Look up',
      notFound: 'There is nobody by that handle.',
      since: 'Account since {{date}}.',
      guest: 'A guest.',
      email: 'E-mail: {{email}}',
      matches: 'Online heists: {{count}}.',
      reports: 'Reports against them: {{open}} open, {{total}} in all.',
      history: 'On record',
      none: 'Nothing on record.',
      kinds: { warn: 'Warning', mute: 'Chat mute', ban: 'Ban' },
      inForce: 'in force',
      lifted: 'lifted',
      over: 'over',
      until: 'until {{date}}',
      untilLifted: 'until lifted',
      lift: 'Lift',
      act: 'Act on this player',
    },
    live: {
      title: 'Live',
      flags: {
        title: 'Feature flags',
        enabled: 'On',
        rollout: 'Share of players (%)',
      },
      config: {
        title: 'Remote configuration',
        key: 'Key',
        value: 'Value (JSON)',
        invalid: 'That is not valid JSON.',
        add: 'Add or change',
        empty: 'Nothing is set: the app uses its own values.',
      },
      news: {
        title: 'News',
        new: 'New piece of news',
        edit: 'Edit',
        titleIt: 'Title (Italian)',
        titleEn: 'Title (English)',
        bodyIt: 'Text (Italian)',
        bodyEn: 'Text (English)',
        publishedAt: 'Published',
        expiresAt: 'Expires (empty: never)',
        pinned: 'Pinned',
        draft: 'Not out yet',
        expired: 'Expired',
        empty: 'No news.',
        cancel: 'Cancel',
      },
    },
    audit: {
      title: 'What the team did',
      empty: 'Nothing yet.',
      by: 'by {{name}}',
    },
  },
};
